/** Provides functionality to create and save new tasks to the Firestore database. */
// @ts-check
import { useAuth } from '@/features/auth/useAuth';
import { useProjectLimitGuard } from '@/features/wall';
import { parseTaskInput } from '@/features/tasks/utils/data/taskParser';
import { executeAddTask } from '@/features/tasks/utils/mutations/taskAddUtils';

const useAddTask = () => {
  const { user } = useAuth();
  const { guardProjects } = useProjectLimitGuard();
  /**
   * @param {string | Partial<NewTask>} input
   * @param {any} [pos]
   */
  const addTask = async (input, pos = null) => {
    const data = typeof input === 'string' ? parseTaskInput(input) : input;
    if (data?.projects?.length && !guardProjects(data.projects)) {
      return null;
    }
    return executeAddTask(user, input, pos);
  };
  return { addTask };
};

export default useAddTask;
